import React from "react";
import { NodeProps } from "@xyflow/react";
import { OwnershipGroupNode } from "../ownership.types";
import styles from "./GroupNode.module.scss";

// The consolidated pill is rendered by GroupHeaderNode as a separate high-z
// node so ownership edges into members pass behind it rather than bisecting it.
export const GroupNode: React.FC<NodeProps<OwnershipGroupNode>> = React.memo(
    () => (
        <div className={styles.boundary}>
            <svg className={styles.boundaryStroke} aria-hidden>
                <rect className={styles.boundaryStrokeRect} x="0.5" y="0.5" />
            </svg>
        </div>
    ),
);
GroupNode.displayName = "GroupNode";
